import { T, cardStyle, tagStyle, selectStyle, inputStyle, inputLabelStyle } from '../ChainView/components/chainSettingsV2Styles';

// Shared by the notification settings cards. Built on the chain settings V2
// tokens so the page looks the same in the fleet, service and chain portals.

export { T, tagStyle, selectStyle, inputStyle, inputLabelStyle };

// The select's white text is inherited by its native option list, which the
// browser draws on a light background. Same fix as the chain V2 settings.
export const optionStyle = { backgroundColor: '#1a1a2e', color: '#fff' };

export const styles = {
  default: {
    page: {
      padding: '24px 32px 48px 32px',
      display: 'flex',
      flexDirection: 'column',
      gap: 20,
      maxWidth: 880,
    },
    card: { ...cardStyle, position: 'relative' },
    header: {
      display: 'flex', alignItems: 'center', gap: 16, marginBottom: 20,
    },
    iconBox: {
      width: 44,
      height: 44,
      borderRadius: 12,
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    icon: { fontSize: 18, color: T.accent },
    title: {
      color: T.textPrimary, fontSize: 18, fontWeight: 600, margin: 0,
    },
    description: {
      color: T.textSecondary, fontSize: 13, margin: '4px 0 0 0', lineHeight: 1.45,
    },
    sectionTitle: {
      color: T.textPrimary,
      fontSize: 12,
      fontWeight: 600,
      letterSpacing: 0.6,
      textTransform: 'uppercase',
      margin: '24px 0 4px 0',
      opacity: 0.8,
    },
    row: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 16,
      padding: '12px 0',
      borderTop: '1px solid ' + T.borderLight,
    },
    firstRow: {
      borderTop: 0,
      paddingTop: 0,
    },
    rowText: {
      display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0,
    },
    rowLabel: {
      color: T.textPrimary, fontSize: 15, fontWeight: 500, margin: 0,
      display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap',
    },
    rowHint: {
      color: T.textSecondary, fontSize: 12, margin: 0, lineHeight: 1.4,
    },
    rowControls: {
      display: 'flex', alignItems: 'center', gap: 14, flexShrink: 0,
    },
    linkButton: {
      background: 'none',
      border: 0,
      padding: 0,
      color: T.textPrimary,
      textDecoration: 'underline',
      fontSize: 12,
      cursor: 'pointer',
    },
    masterRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 16,
      padding: '14px 16px',
      borderRadius: T.radius,
      backgroundColor: T.cardStrong,
      border: '1px solid ' + T.border,
    },
    emptyText: {
      color: T.textSecondary, fontSize: 13, margin: '8px 0 0 0',
    },
    banner: {
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      padding: '10px 14px',
      borderRadius: T.radius,
      backgroundColor: 'rgba(255, 255, 255, 0.18)',
      border: '1px solid rgba(255, 255, 255, 0.35)',
      color: T.textPrimary,
      fontSize: 14,
    },
    searchResults: {
      marginTop: 8,
      borderRadius: T.radius,
      backgroundColor: T.inBg,
      padding: '4px 12px',
    },
  },
  medium: {
    page: { padding: '16px 0 32px 0' },
    card: { ...cardStyle, padding: 16 },
  },
  small: {
    row: { alignItems: 'flex-start' },
    masterRow: { alignItems: 'flex-start', padding: '12px' },
  },
};
